import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import { useTranslate } from 'hooks/useTranslate';
import CustomLoading from 'modules/_shared/components/CustomLoading';
import CKEditor from 'modules/_shared/components/CKEditor';

import { EQUITY_MARKET_CONTRACT_TEMPLATE_VARIABLES } from '../constants/equityMarketContractTemplateVariables';
import { useEditEquityMarketSharePurchaseContractTemplateModal } from '../context/EditEquityMarketSharePurchaseContractTemplateModalContext';

const EditEquityMarketSharePurchaseContractTemplateModalBody: FC = () => {
  const { t } = useTranslate();
  const { data, actions } =
    useEditEquityMarketSharePurchaseContractTemplateModal();

  if (data.isLoading) {
    return (
      <Modal.Body className="position-relative" style={{ minHeight: 200 }}>
        <CustomLoading />
      </Modal.Body>
    );
  }

  if (data.loadError) {
    return (
      <Modal.Body>
        <p className="text-danger mb-0">
          {t('EquityMarketContractTemplateLoadError')}
        </p>
      </Modal.Body>
    );
  }

  return (
    <Modal.Body>
      <div className="nk-modal">
        <p className="text-soft mb-3 fs-13px">
          {t('EditEquityMarketSharePurchaseContractTemplateIntro')}
        </p>

        <div className="mb-3">
          <p className="overline-title text-soft mb-2">
            {t('EquityMarketContractAvailableVariables')}{' '}
            <span className="text-soft fw-normal fs-12px">
              {t('EquityMarketContractVariablesHint')}
            </span>
          </p>
          <div
            className="d-flex flex-wrap align-items-center"
            style={{ gap: 8 }}
          >
            {EQUITY_MARKET_CONTRACT_TEMPLATE_VARIABLES.map(
              ({ token, labelKey }) => (
                <span
                  key={token}
                  className="btn btn-light badge badge-sm badge-light cursor-pointer"
                  onClick={() => actions.insertVariable(token)}
                >
                  {t(labelKey)}
                </span>
              )
            )}
          </div>
        </div>

        <CKEditor
          editorInstance={data.editorInstance}
          setEditorInstance={actions.setEditorInstance}
          documentName="EquityMarketContract"
          documentModel={data.contractText}
          enableMentions={false}
          isReadOnly={false}
          onChangeContent={actions.onEditorChange}
        />
      </div>
    </Modal.Body>
  );
};

export default EditEquityMarketSharePurchaseContractTemplateModalBody;
